/**
 * True when the game runs inside the packaged desktop app (Electron) rather than a browser.
 * The bridge is injected by the preload script - see electron/preload.cjs.
 */
export default function isDesktop() {
  return global?.allkaraokeDesktop !== undefined;
}
